// This file should only contain action type constants.
export const SET_MORE_REQUEST_DATA = 'SET_MORE_REQUEST_DATA';
